import { Subscription } from 'rxjs';
// Angular
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit,Renderer2 } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
// Layout
import { LayoutConfigService, MenuAsideService, MenuHorizontalService, SplashScreenService } from './core/_base/layout';
import { SuperAdminApiService } from 'src/app/Services/superAdmin.service';
import { UtilsService } from 'src/app/Services/utils.service';
import { OtherApiService } from './Services/other.service';
import { CancelHttpService } from './Services/cancelHttpSerivce.service';
import { AuthApiService } from 'src/app/Services/auth.service';
import { LayoutService } from './Services/layout.service';
import { environment } from 'src/environments/environment';
// language list
declare let gtag: Function;

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
	// Public properties
	title = 'Loading...';
	loader: boolean;
	appInitialized = window['appInitialized'];
	loading: boolean = true; // Initialize loading to true to show splash screen initially
	primaryColour = localStorage.getItem('primaryColour');
	secondaryColour = localStorage.getItem('secondaryColour');
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	titleName: string;
	userType: string;
	qac: string;
	private sub: Subscription;
	browserDomain: string;

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 * @param layoutConfigService: LayoutCongifService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(
		private renderer: Renderer2,
		private router: Router,
		private cancelHttp: CancelHttpService,
				         private layoutConfigService: LayoutConfigService,
						 private splashScreenService: SplashScreenService,
						 private otherService : OtherApiService,
						 private ref:ChangeDetectorRef,
						 private service : SuperAdminApiService,
						 private util:UtilsService,
						 private authService: AuthApiService,
						 private layoutService: LayoutService) {
							this.router.events.subscribe(event => {
								if (event instanceof NavigationStart) {
								  this.cancelHttp.cancelAllRequests(); // 🔥 cancel ALL HTTP calls
								  if (event.url && event.url.includes('extramarksforte.com')) {
									let cleanUrl = '';
									if (event.url.includes('faculty-admin-dashboard')) { cleanUrl = 'https://extramarksforte.com/faculty-admin-dashboard'; }
									else if (event.url.includes('faculty-assessment-dashboard')) { cleanUrl = 'https://extramarksforte.com/faculty-assessment-dashboard'; }
									else {
										const match = event.url.match(/(https?):\/+(extramarksforte\.com[^)]*)/);
										cleanUrl = match ? match[1] + '://' + match[2] : 'https://extramarksforte.com';
									}
									window.location.href = cleanUrl;
								  }
								}
							  });
							this.checkCurrentDate()
						this.colourThemeSetting();
						this.getWhiteLabellingByURL();
						this.router.events.subscribe(event => {
							if(event instanceof NavigationEnd){
					  	  		gtag('config', 'G-2KY7F9S7TP', {'page_path': event.urlAfterRedirects});
							}
						})
						// The splash screen is now controlled by the `loading` flag initialized to true.
						// The `splashScreenService.hide()` will be called by the APP_INITIALIZER when the app is ready.
						this.router.events.subscribe(event => {
							if (event instanceof NavigationStart) {
								// Set loading to true on navigation start to show progress for subsequent navigations
								this.loading = true;
								this.ref.markForCheck();
								setTimeout(() => {
									if (this.loading) {
										this.loading = false;
										this.splashScreenService.hide();
										this.appInitialized = false;
										this.ref.markForCheck();
									}
								}, 15000);
							}
							if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
								if (event instanceof NavigationError) {
									console.error('NavigationError', event.url, event.error);
								}
								this.splashScreenService.hide();
								this.loading = false;
								this.appInitialized = false; // This is for the initial loader, not splash screen
								this.ref.markForCheck();
								window.scrollTo(0, 0);
							}
						})
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */

	ngOnInit(): void {
    this.router.events.subscribe(event => {
      console.log('Router Event:', event); //gives us some information regarding routes event if any error occured
    });
		this.browserDomain = this.otherService.browserDomain;
		window.onbeforeprint = () => {
			const table = document.getElementById('salaryMonthWisePrintReportTable');
			if (table) {
			  this.renderer.removeClass(table, 'table');
			}
		  };
		    this.router.events.subscribe(event => {
     // console.log('Router Event:', event); //gives us some information regarding routes event if any error occured
    });
    this.router.events.subscribe(event => {
    //   console.log('Router Event:', event); //gives us some information regarding routes event if any error occured
    });
		  window.onafterprint = () => {
			const table = document.getElementById('salaryMonthWisePrintReportTable');
			if (table) {
			  this.renderer.addClass(table, 'table');
			}
		  };

		const params = new URLSearchParams(window.location.search);
		const isEmbedded = params.get('embedded') === 'true' || window.self !== window.top;
		this.layoutService.setEmbedded(isEmbedded);
		if (isEmbedded) {
			this.renderer.addClass(document.body, 'embedded');
		}
		if (window.location.hostname.includes('extramarks') || (this.browserDomain && this.browserDomain.includes('extramarks'))) {
			this.renderer.addClass(document.body, 'is-extramarks');
		}

		this.loader = this.layoutConfigService.getConfig('loader.enabled');
		// The initial loading state is now handled by the `loading` property initialized to true.
		// The `splashScreenService.hide()` is called by the APP_INITIALIZER.
		this.checkTokenFallback();
		this.saveTokenToCookie();
		//this.loading = true;
		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
					this.checkCurrentDate();
				// hide splash screen
				this.splashScreenService.hide();
				this.loading = false;
				this.appInitialized = false
				this.ref.markForCheck();
				// scroll to top on every route change
				window.scrollTo(0, 0);

				// to display back the body content
				setTimeout(() => {
					document.body.classList.add('kt-page--loaded');
				}, 500);
			}
			if (event instanceof NavigationCancel || event instanceof NavigationError) {
				this.splashScreenService.hide();
				this.loading = false;
				this.appInitialized = false;
				this.ref.markForCheck();
			}
		});
		this.unsubscribe.push(routerSubscription);

	}

	checkCurrentDate()
	{
		const token = localStorage.getItem('token');
		if (!token) {
			return;
		}
		if (window.location.href.includes('webOPAC')) {
			return;
		}

		this.userType = localStorage.getItem('userType');
		this.qac = localStorage.getItem('qac');
		this.otherService.checkCurrentDate()
		.subscribe(res=>{
			const now = Date.now(); // local timestamp in milliseconds
			const apiTime = new Date(res.currentDate).getTime(); // API timestamp in milliseconds

			const diffInMinutes = Math.abs((now - apiTime) / (1000 * 60));
			const flag = diffInMinutes > 5;

			if (flag) {
			  this.util.alertNotificationMessage("Please check your system date");
			  let userType = this.userType;
			  let qac = this.qac;
			  localStorage.removeItem('token');
			  localStorage.removeItem('name')
			  localStorage.removeItem('userType');
			  localStorage.removeItem('session');
			  localStorage.removeItem('mobile');
			  localStorage.removeItem('sessionEndDate');
			  localStorage.removeItem('sessionStartDate');
			  localStorage.removeItem('entityType');
			  localStorage.removeItem('entityId');
			  localStorage.removeItem('homeEntityId');
              localStorage.removeItem('courseByTeacherData')
              localStorage.removeItem('courseByTeacherDataDateWise');
			  localStorage.removeItem('entityData');
			  localStorage.removeItem('logo')
			  localStorage.removeItem('entityName')
			  localStorage.removeItem('primaryColour')
			  localStorage.removeItem('entityGroup')
			  localStorage.removeItem('permissions')
			  localStorage.removeItem('secondaryColour')
			  localStorage.removeItem('entityPreferences')
			  localStorage.removeItem('studentFields') // legacy key cleanup
			  localStorage.removeItem('userPreferences')
			  localStorage.removeItem('qac')
			  localStorage.removeItem('employee')
			  localStorage.removeItem('employeeId')
			  localStorage.removeItem('employeeType')
			  localStorage.removeItem('layoutConfig');
			  localStorage.removeItem('language');
			  localStorage.removeItem('activeSessionStartDate');
			  localStorage.removeItem('status');
			  localStorage.removeItem('superSession');
			  localStorage.removeItem('communicationSetup');
			  localStorage.removeItem('tourStage')
			  localStorage.removeItem('welcomeTour')
			  localStorage.removeItem('demandSession')
			  const hasXToken = !!this.util.getCookie('x-token');
			  const hasNoRedirect = !!this.util.getCookie('noRedirect');
			  this.util.removeCookie('x-token');
			  this.util.removeCookie('noRedirect');
			  localStorage.removeItem('isExternalLogin');
			  // localStorage.clear();
			  if (hasXToken && !hasNoRedirect) {
				  window.location.href = environment.extraMarksConfig.logout;
			  } else if(userType == 'od4'){
			  this.router.navigate(['/auth/'+qac]);
			  }else{
				  this.router.navigate(['/auth/'+qac+'/staff'])
			  }
			  return;
			}
		},err=>{
			this.util.errmsg(err);
			this.ref.detectChanges();
		})
	}
	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		window.onbeforeprint = null;
		window.onafterprint = null;

		this.unsubscribe.forEach(sb => sb.unsubscribe());
		if (this.sub) this.sub.unsubscribe();
	}
	colourThemeSetting(){
		document.documentElement.style.setProperty('--primary-color', this.primaryColour);
		document.documentElement.style.setProperty('--secondary-color', this.secondaryColour);
		document.documentElement.style.setProperty('--tertiary-color', this.primaryColour+14);
	}

	getWhiteLabellingByURL(){
		let url = window.origin;
		localStorage.removeItem('copyrightName');
		localStorage.removeItem('displayLogo');
		localStorage.removeItem('titleName',);
		localStorage.removeItem('displayDescription');
		localStorage.removeItem('displayName');
		localStorage.removeItem('titleLogo');
		localStorage.removeItem('tncUrl');
		localStorage.removeItem('privacyPolicyUrl');
		localStorage.removeItem('disclaimerUrl');
		localStorage.removeItem('loginRedirect');
		this.service.getWhiteLabellingByURL(url)
		.subscribe(res=>{
			localStorage.removeItem('loadingLogo');
			if(res.urls.length>0){
				for(let item of res.urls){
					if(item.url == window.origin){
						localStorage.setItem('loginRedirect', item.redirectTo);
					}
				}
			}
			if(res.copyrightName){
				localStorage.setItem('copyrightName', res.copyrightName);
			}
			if(res.displayLogo){
				localStorage.setItem('displayLogo', res.displayLogo);
				this.service.logoUpdated.next(res.displayLogo);
			}
			if(res.titleName){
				localStorage.setItem('titleName', res.titleName);
			}
			if(res.displayDescription){
				localStorage.setItem('displayDescription', res.displayDescription);
			}
			if(res.displayName){
				localStorage.setItem('displayName', res.displayName);
			}
			if(res.loadingLogo){
				localStorage.setItem('loadingLogo', res.loadingLogo);
			}
			if(res.titleLogo){
				localStorage.setItem('titleLogo', res.titleLogo);

			}
			if(res.tncUrl){
				localStorage.setItem('tncUrl', res.tncUrl);
			}
			if(res.privacyPolicyUrl){
				localStorage.setItem('privacyPolicyUrl', res.privacyPolicyUrl);
			}
			if(res.disclaimerUrl){
				localStorage.setItem('disclaimerUrl', res.disclaimerUrl);
			}
			if(localStorage.getItem('titleName')){
				document.title = localStorage.getItem('titleName')
			} else {
				document.title = 'Okie Dokie';
			}
			if(localStorage.getItem('titleLogo')){
				document.getElementById('titleLogo').setAttribute('href', localStorage.getItem('titleLogo'));
			}
		},
		err=>{
			document.title = 'Okie Dokie';
		})
	}

	saveTokenToCookie() {
		const token = localStorage.getItem('token');
		const isExternalLogin = localStorage.getItem('isExternalLogin');
		if (token) {
			this.util.setCookie('x-token', token);
			if (!isExternalLogin) {
				this.util.setCookie('noRedirect', 'true');
			}
		}
	}

	checkTokenFallback() {
		const localStorageToken = localStorage.getItem('token');
		const userType = localStorage.getItem('userType');

		// Check for standardized 'x-token' or legacy 'token' cookie
		let cookieToken = this.util.getCookie('x-token') || this.util.getCookie('token');

		if (cookieToken && !localStorageToken) {
			// Restore session from cookie if localStorage is empty
			cookieToken = cookieToken.replace(/^"|"$/g, '');

			// Temporarily sync to localStorage so interceptor can use it for the verification call
			localStorage.setItem('token', cookieToken);
			localStorage.setItem('isExternalLogin', 'true');
			this.authService.getUserDetails(cookieToken).subscribe(res => {
				if (res) {
					this.saveUserDataToLocalStorage(res, cookieToken);
				} else {
					this.clearLocalStorageAndRedirect();
				}
			}, err => {
				this.clearLocalStorageAndRedirect();
			});
		}
		// else if (!localStorageToken || !userType) {
		// 	// No cookie found and localStorage is empty/incomplete, redirect to sign-in
		// 	this.redirectToSignIn();
		// }
		// else {
		// 	// Valid localStorage session exists, skip API verification
		// 	// But ensure user is redirected if they are on an auth page
		// 	if (window.location.pathname.includes('/auth')) {
		// 		this.redirectUserBasedOnType();
		// 	}
		// }
	}

	private redirectUserBasedOnType() {
		const userType = localStorage.getItem('userType');
		if (userType === 'od4') {
			window.location.href = this.authService.browserDomain + '/studentDashboard';
		} else {
			switch (userType) {
				case "od1":
					window.location.href = this.authService.browserDomain + '/dashboard';
					break;
				case "od2":
				case "od3":
					const entity = JSON.parse(localStorage.getItem('entityData') || '{}');
					if (entity && !entity.activeSession) {
						window.location.href = this.authService.browserDomain + '/schoolSetup/academicSession';
					} else {
						window.location.href = this.authService.browserDomain + '/entity/dashboard';
					}
					break;
				default:
					// Do nothing or generic redirect
					break;
			}
		}
	}

	private clearLocalStorageAndRedirect() {
		const hasXToken = !!this.util.getCookie('x-token');
		const hasNoRedirect = !!this.util.getCookie('noRedirect');
		localStorage.removeItem('token');
		localStorage.removeItem('isExternalLogin');
        localStorage.removeItem('estimatedCollections');
		localStorage.removeItem('estimatedCollectionsDate');
		this.util.removeCookie('x-token');
		this.util.removeCookie('noRedirect');
		this.util.removeCookie('token');
		if (hasXToken && !hasNoRedirect) {
			window.location.href = environment.extraMarksConfig.logout;
		} else {
			this.redirectToSignIn();
		}
	}

	private redirectToSignIn() {
		if (!window.location.pathname.includes('/auth') && !window.location.pathname.includes('/webOPAC')) {
			const qac = localStorage.getItem('qac');
			if (qac) {
				const userType = localStorage.getItem('userType');
				if (userType === 'od4') {
					this.router.navigate(['/auth/' + qac]);
				} else {
					this.router.navigate(['/auth/' + qac + '/staff']);
				}
			} else {
				// Fallback to generic auth if no QAC found
				this.router.navigate(['/auth']);
			}
		}
	}

	saveUserDataToLocalStorage(res: any, token: string) {
		const finalToken = res.token || token;
		localStorage.setItem('token', finalToken);
		localStorage.setItem('isExternalLogin', 'true');

		localStorage.setItem('name', res.name);
		localStorage.setItem('userType', res.userType)
		localStorage.setItem('mobile', res.mobile);
		localStorage.setItem('userId', res._id);
		localStorage.setItem('permissions', res.permissions)
		localStorage.setItem('primaryColour', '#1ca9c9');
		localStorage.setItem('secondaryColour', '#ffffff');
		if (res.entity) {
			localStorage.setItem('contactEmail', res.entity.contactEmail);
			localStorage.setItem('entityName', res.entity.displayName || res.entity.name);
		}

		switch (res.userType) {
			case "od1":
				const adminTarget = '/dashboard';
				if (!window.location.pathname.includes(adminTarget)) {
					window.location.href = this.browserDomain + adminTarget;
				}
				break;
			case "od4":
				const studentTarget = '/studentDashboard';
				if (!window.location.pathname.includes(studentTarget)) {
					window.location.href = this.browserDomain + studentTarget;
				}
				break;
			case "od2":
			case "od3":
				if (res.entityGroup) {
					localStorage.setItem('entityGroup', JSON.stringify(res.entityGroup))
				}
				else {
					localStorage.setItem('entityGroup', JSON.stringify([]))
				}
				localStorage.setItem('entityId', res.entity._id);
				localStorage.setItem('homeEntityId', res.entity._id);
				localStorage.setItem('qac', res.entity.qac);
				if (res.employee) {
					localStorage.setItem('employee', res.employee);
				}
				if (res.myOperatorId) {
					localStorage.setItem('myOperatorId', res.myOperatorId);
				}
				if (res.admissionSource) {
					localStorage.setItem('admissionSource', JSON.stringify(res.admissionSource));
				}
				if (res.employeeId) {
					localStorage.setItem('employeeId', res.employeeId);
				}
				if (res.employeeType) {
					localStorage.setItem('employeeType', res.employeeType);
				}
				localStorage.setItem('entityData', JSON.stringify(res.entity));
				localStorage.setItem('logo', res.entity.logo);
				localStorage.setItem('tourStage', res.entity.tourStage)
				localStorage.setItem('welcomeTour', res.entity.welcomeTour)
				localStorage.setItem('staticQR', res.entity.staticQR);
				localStorage.setItem('entityPreferences', JSON.stringify(res.entity.entityPreferences))
				if (res.userPreferences) {
					localStorage.setItem('userPreferences', JSON.stringify(res.userPreferences));
				}
				if (res.entity.entityPreferences && res.entity.entityPreferences.primaryColour) {
					localStorage.setItem('primaryColour', res.entity.entityPreferences.primaryColour);
					if (res.entity.entityPreferences.primaryColour == '#ffffff' || res.entity.entityPreferences.primaryColour == '#fff') {
						localStorage.setItem('primaryColour', '#1ca9c9');
					}
				}
				if (res.entity.entityPreferences && res.entity.entityPreferences.secondaryColour) {
					localStorage.setItem('secondaryColour', res.entity.entityPreferences.secondaryColour);
				}
				if (res.entity.communicationSetup) {
					localStorage.setItem('communicationSetup', JSON.stringify(res.entity.communicationSetup))
				}
				// localStorage.setItem('entityName', res.entity.name)
				localStorage.setItem('entityName', res.entity.displayName)
				localStorage.setItem('entityType', res.entity.entityType)
				if (!res.entity.activeSession) {
					this.util.alertNotificationMessage('Please Activate A Session First');
					// this.router.navigate(['/academicSession'])
					window.location.href = this.browserDomain + '/schoolSetup/academicSession';
					// this.util.redirect('/academicSession')
					// return
				} else {
					// localStorage.setItem('session', res.entity.activeSession.name);
					// localStorage.setItem('session', res.userPreferences.session);
					localStorage.setItem('session', res.entity.activeSession.name);
					localStorage.setItem('superSession', res.entity.activeSession.superSession);
					localStorage.setItem('sessionStartDate', res.entity.activeSession.startDate);
					localStorage.setItem('sessionEndDate', res.entity.activeSession.endDate);
					const entityTarget = '/entity/dashboard';
					if (res.userPreferences && res.userPreferences.session) {
						this.authService.fetchSession(res.entity._id, res.userPreferences.session)
							.subscribe(res => {
								localStorage.setItem('session', res.name);
								localStorage.setItem('superSession', res.superSession);
								localStorage.setItem('sessionStartDate', res.startDate);
								localStorage.setItem('sessionEndDate', res.endDate);
								if (!window.location.pathname.includes(entityTarget)) {
									window.location.href = this.browserDomain + entityTarget;
								}
							}, err => {
								this.util.confirmAlert('Preferred session not found in this institute, switched to active session').subscribe((sure: boolean) => {
									if (sure) {
										if (!window.location.pathname.includes(entityTarget)) {
											window.location.href = this.browserDomain + entityTarget;
										}
									} else {
										this.loading = false
										this.logout()
										this.ref.detectChanges()
									}
								})


							})
					} else {
						if (!window.location.pathname.includes(entityTarget)) {
							window.location.href = this.browserDomain + entityTarget;
						}
					}


					// this.util.redirect('/entityDashboard')
				}
				break;
			default: {
				this.util.redirect('/auth/register')
			}
		}
	}
 logout() {
	const hasXToken = !!this.util.getCookie('x-token');
	const hasNoRedirect = !!this.util.getCookie('noRedirect');
	const userType = localStorage.getItem('userType');
	const qac = localStorage.getItem('qac');
    localStorage.removeItem('token');
    localStorage.removeItem('isExternalLogin');
    localStorage.removeItem('name')
    localStorage.removeItem('userType');
    localStorage.removeItem('session');
    localStorage.removeItem('mobile');
    localStorage.removeItem('sessionEndDate');
    localStorage.removeItem('sessionStartDate');
    localStorage.removeItem('entityType');
    localStorage.removeItem('entityId');
    localStorage.removeItem('homeEntityId');
    localStorage.removeItem('entityData');
    localStorage.removeItem('logo')
    localStorage.removeItem('entityName')
    localStorage.removeItem('primaryColour')
    localStorage.removeItem('entityGroup')
    localStorage.removeItem('permissions')
    localStorage.removeItem('secondaryColour')
    localStorage.removeItem('entityPreferences')
    localStorage.removeItem('studentFields') // legacy key cleanup
    localStorage.removeItem('userPreferences')
    localStorage.removeItem('qac')
    localStorage.removeItem('employee')
    localStorage.removeItem('employeeId')
    localStorage.removeItem('employeeType')
    localStorage.removeItem('layoutConfig');
    localStorage.removeItem('language');
    localStorage.removeItem('activeSessionStartDate');
    localStorage.removeItem('status');
    localStorage.removeItem('superSession');
    localStorage.removeItem('communicationSetup');
    localStorage.removeItem('tourStage')
    localStorage.removeItem('welcomeTour')
    localStorage.removeItem('admissionSource')
    localStorage.removeItem('courseByTeacherData')
    localStorage.removeItem('courseByTeacherDataDateWise');
	localStorage.removeItem('estimatedCollections');
		localStorage.removeItem('estimatedCollectionsDate');
	this.util.removeCookie('x-token');
	this.util.removeCookie('noRedirect');
    // localStorage.clear();
	if (hasXToken && !hasNoRedirect) {
		window.location.href = environment.extraMarksConfig.logout;
	} else if (userType == 'od4') {
		this.router.navigate(['/auth/' + qac]);
	} else {
		this.router.navigate(['/auth/' + qac + '/staff']);
	}


  }
}
